import { createContext, useState, useEffect } from "react";

const UserContext = createContext();

const SESSION_KEY = "affordable_option_session";
const SESSION_DURATION = 14 * 60 * 60 * 1000; // 14 hours in milliseconds

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Load user from localStorage on mount
  useEffect(() => {
    const loadUser = () => {
      try {
        const sessionData = localStorage.getItem(SESSION_KEY);
        if (sessionData) {
          const { user: storedUser, timestamp } = JSON.parse(sessionData);
          const now = Date.now();

          // Check if session is still valid (within 14 hours)
          if (now - timestamp < SESSION_DURATION) {
            setUser(storedUser);
          } else {
            // Clear expired session
            localStorage.removeItem(SESSION_KEY);
          }
        }
      } catch (error) {
        console.error("Error loading user session:", error);
        localStorage.removeItem(SESSION_KEY);
      }
    };

    loadUser();
  }, []);

  // Update localStorage when user changes
  useEffect(() => {
    if (user) {
      try {
        const sessionData = {
          user,
          timestamp: Date.now(),
        };
        localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
      } catch (error) {
        console.error("Error saving user session:", error);
        localStorage.removeItem(SESSION_KEY);
      }
    } else {
      localStorage.removeItem(SESSION_KEY);
    }
  }, [user]);

  const logout = () => {
    setUser(null);
    localStorage.removeItem(SESSION_KEY);
  };

  return (
    <UserContext.Provider value={{ user, setUser, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserProvider, UserContext };
